import { Component, Input, OnDestroy } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-order-flow-header',
  templateUrl: './order-flow-header.component.html',
  styleUrls: ['./order-flow-header.component.scss']
})
export class OrderFlowHeaderComponent implements OnDestroy {
  goToPageLink: string;
  goToPageText: string;
  private routerSubscription: Subscription;

  orderFlowPages = [
    { to: '/order-summary', text: 'Go back to Summary', currentLocation: '/select-meals' },
    { to: '/order-summary', text: 'Go back to Summary', currentLocation: '/order-checkout' },
    { to: '/order-flow', text: 'Go back to Questions', currentLocation: '/order-summary' }
  ];

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.updatePageLinks();
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => this.updatePageLinks());
  }

  ngOnDestroy(): void {
    this.routerSubscription?.unsubscribe();
  }

  private updatePageLinks(): void {
    const currentUrl = this.router.url.split('?')[0];
    const currentPage = this.orderFlowPages.find(page => page.currentLocation === currentUrl);
    this.goToPageLink = currentPage?.to ?? '';
    this.goToPageText = currentPage?.text ?? '';
  }

  navigateToPage(): void {
    if (this.goToPageLink === '/order-flow') {
      localStorage.removeItem('cart');
    }
    this.router.navigate([this.goToPageLink]);
  }

  goToHome(){
    this.router.navigate(['/home']);
  }
}